import { useMemo } from 'react';
import {
	useAnalyticsEvents as useAnalyticsEventsBridge,
	fireAnalytics,
	type EventTypes,
} from '@atlassian/jira-product-analytics-bridge';

const AnalyticsWebClientTypeToJiraEventType = {
	sendTrackEvent: 'TRACK',
	sendUIEvent: 'UI',
	sendScreenEvent: 'SCREEN',
	sendOperationalEvent: 'OPERATIONAL',
} as const satisfies Record<string, EventTypes>;
type AWCType = keyof typeof AnalyticsWebClientTypeToJiraEventType;

export const useAnalyticsEvents = () => {
	const { createAnalyticsEvent: createAnalyticsEventNotFireable } = useAnalyticsEventsBridge();
	return useMemo(() => {
		const createAnalyticsEvent: typeof createAnalyticsEventNotFireable = (payload) => {
			const event = createAnalyticsEventNotFireable(payload);

			// event.fire() coming from `createAnalyticsEvent` does not actually send the event in Jira,
			// so we need to patch it here, ensuring it goes throught the analytics bridge correctly
			event.fire = () => {
				const awcType: AWCType = payload.type;
				const jiraBridgeEventType = AnalyticsWebClientTypeToJiraEventType[awcType];
				if (!jiraBridgeEventType) {
					return;
				}
				fireAnalytics(event, jiraBridgeEventType, payload.data);
			};

			return event;
		};

		return { createAnalyticsEvent };
	}, [createAnalyticsEventNotFireable]);
};
